import axios from '../axios';
import { OPEN_AI_PRODUCT_NAME, OPEN_AI_PRODUCT_DESCRIPTION } from '../ApiUrl';

export const openAiProductNameAPI = async (payload = {}) => {
  try {
    const response = await axios.post(OPEN_AI_PRODUCT_NAME, payload);
    return response;
  } catch (error) {
    console.log('openAiAPI catch block', error);
    return { success: false, error };
  }
};

export const openAiProductDescriptionAPI = async (payload = {}) => {
  try {
    const response = await axios.post(OPEN_AI_PRODUCT_DESCRIPTION, payload);
    return response;
  } catch (error) {
    console.log('openAiDescriptionAPI catch block', error);
    return { success: false, error };
  }
};
